import React from "react";
import BreadCrumbs from "Components/Fragment/BreadCrumbs";
import { Grid } from "Components/Base/Layout/Grid";

const PageHeader = ({ crumbs = [], pageTitle }) => {
  return (
    <Grid container direction="column">
      {Array.isArray(crumbs) && crumbs.length > 0 && (
        <Grid item>
          <BreadCrumbs crumbs={crumbs} />
        </Grid>
      )}
      <Grid item>
        <h1>{pageTitle}</h1>
      </Grid>
    </Grid>
  );
};

export default PageHeader;